import { MerchantId, SetHeaderService } from "@/helper/authenticationHelper";
import { DocumentTemplateHeaderTypeModel, DocumentWithPassCodeModel } from "@/model/document/documentModel";
import service from "../../baseHttpService";
import {
  PrepareDocumentInputData,
  PrepareDocumentPublicLinkInputData,
  PrepareUpdateDetailDocumentInputData,
} from "../documentFacade";

class QuotationService {
  DoGetQuotationDocumentPublicLink(input: DocumentWithPassCodeModel) {
    const _input = {
      merchantId: MerchantId(),
      data: PrepareDocumentPublicLinkInputData(input),
    };
    return service.peakOnlineView
      .post("/api/Quotation/GetQuotationDocumentPublicLink", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoGetQuotationDocument(input: DocumentTemplateHeaderTypeModel) {
    const _input = {
      merchantId: MerchantId(),
      data: PrepareDocumentInputData(input),
    };
    return service.peakOnlineView
      .post("/api/Quotation/GetQuotationDocument", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoUpdateQuotationDetailDocument(input: any) {
    const _input = {
      merchantId: MerchantId(),
      data: PrepareUpdateDetailDocumentInputData(input),
    };
    return service.peakOnlineView
      .post("/api/Quotation/UpdateQuotationDetailDocument", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
}

export default new QuotationService();
